﻿import { api } from '@cwd/lib/main';
import { type SurveyInList, type SurveyCount, type Survey, type GlobalTemplate } from './SurveysTypes';

export async function loadSurveys(query: string): Promise<SurveyInList[]> {
    return api.get('/Surveys' + query);
}

export async function endSurvey(id: string): Promise<SurveyInList> {
    return api.post('/Surveys/' + id + '/End');
}

export async function loadSurveyCount(): Promise<SurveyCount> {
    return api.get('/Surveys/CountByStatus');
}

export async function deleteSelected(list: { SurveyId: string }[]): Promise<string> {
    return api.delete(`/Surveys`, list);
}

export async function loadSurvey(id: string): Promise<Survey> {
    return api.get('/Surveys/' + id);
}

export async function loadGlobalTemplates(): Promise<GlobalTemplate[]> {
    return api.get('/GlobalSurveyTemplates?$expand=Tags&$select=Title,Description,ImageUrl,SortOrder,SurveyId,Tags');
}

export async function createSurveyFromGlobalTemplate(id: string, eventId?: string): Promise<Survey> {
    return api.post('/Surveys/' + id + '/CloneFromTemplate' + (eventId ? '?eventId=' + eventId : ''));
}

export async function createSurveyFromPrevious(id: string, eventId?: string): Promise<Survey> {
    return api.post('/Surveys/' + id + '/Clone' + (eventId ? '?eventId=' + eventId : ''));
}
